// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { getUserId } from '~/core/state/user/selectors';
import { pick } from 'lodash/fp';
import Raven from 'raven-js';

type Props = { children: React.Node, id: string };

class RavenUserSetup extends React.Component<Props, void> {
    componentDidMount() {
        this.setupUser(this.props);
    }

    componentWillReceiveProps = this.setupUser;
    setupUser = props => Raven.setUserContext(pick(['id'], props));
    render = () => this.props.children;
}

const mapStateToProps = (state): { id: string } => ({
    id: getUserId(state)
});

export default connect(mapStateToProps, null, null, { pure: false })(RavenUserSetup);



// WEBPACK FOOTER //
// ./src/components/raven-user-setup/index.js